export const getEnvURLs = () => {
    const urls = {
        sso: 'https://sso.xtendlive.com',
        sso_api: 'https://sso-api.xtendlive.com',
        eco: 'https://shop.xtendlive.com',
        ws: 'https://omnichat.xtendlive.com',
    };

    if (window.location.host.includes('.dev.')) {
        urls.sso = 'https://sso.dev.xtendlive.com';
        urls.sso_api = 'https://sso-api.dev.xtendlive.com';
        urls.eco = 'https://shop.dev.xtendlive.com';
        urls.ws = 'https://omnichat.dev.xtendlive.com';
    }

    if (window.location.host.includes('.qa.')) {
        urls.sso = 'https://sso.qa.xtendlive.com';
        urls.sso_api = 'https://sso-api.qa.xtendlive.com';
        urls.eco = 'https://shop.qa.xtendlive.com';
        urls.ws = 'https://omnichat.qa.xtendlive.com';
    }

    if (window.location.host.includes('.pre.')) {
        urls.sso = 'https://sso.pre.xtendlive.com';
        urls.sso_api = 'https://sso-api.pre.xtendlive.com';
        urls.eco = 'https://shop.pre.xtendlive.com';
        urls.ws = 'https://omnichat.pre.xtendlive.com';
    }

    // Local k3d stack (xl-local-cluster): hubs live at <name>.<base> over
    // plain http and none of the environment suffixes above match, which
    // used to silently select the PROD urls. Build-time only; unset in every
    // real environment. Suffix match on a dot boundary so a base like
    // "xtendlive.com" can never shadow the dev/qa/pre branches. hostname,
    // not host: host carries a port (vite dev server), which breaks endsWith.
    const localBase = import.meta.env.VITE_LOCAL_BASE_DOMAIN;
    const hostname = window.location.hostname;
    if (localBase && hostname.endsWith(`.${localBase}`)
        && !/\.(dev|qa|pre)\./.test(hostname)) {
        urls.sso = `http://sso.${localBase}`;
        urls.sso_api = `http://sso-api.${localBase}`;
        urls.eco = `http://shop.${localBase}`;
        urls.ws = `http://omnichat.${localBase}`;
    }

    urls.cms_api = `${window.location.protocol}/${window.location.host}/cms/api`;
    return urls;
};
